export default class UIService {
    removePreloader(): void {
      const preloader = document.querySelector('.first-loader__wrapper');
      if (preloader) {
        preloader.remove();
      }
    }
}
